// This file has one purpose: expose jQuery to the global scope for legacy scripts.
import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

globalThis.jQuery = jQuery;
globalThis.$ = jQuery;

require('bootstrap/dist/js/bootstrap.min.js');